(function () {
    'use strict';

    angular.module('thankview.recorder')
        .factory('uploadService', ['$rootScope', 'webcamService', '$window', 'httpProgress', 'logEventService', function ($rootScope, webcamService, $window, httpProgress, logEventService) {
            var uploadPercentage = 0;
            var uploadService = {};
            var uploadFile;

            uploadService.uploadFile = function (e) {
                uploadFile = e.target.files[0];
                if ($window.Bugsnag) {
                    Bugsnag.leaveBreadcrumb('User attached file', {
                        file: uploadService.getUploadFileMetadata(),
                    });
                }
                uploadService.postFile();
            };

            uploadService.reUploadFile = function () {
                uploadService.postFile();
            };

            uploadService.postFile = function () {
                logEventService.addEvent('Upload to ' + config.mediaUrl, 'Function');

                var url = config.mediaUrl + '/api/upload/video';
                var formData = new $window.FormData();
                formData.append('file', uploadFile);
                formData.append('id', config.user.id);
                var videoId = webcamService.getVideoId();
                var lastPercentage = -1;
                $rootScope.$broadcast('recorder-uploading', 0, videoId);

                httpProgress.post(url, formData, {
                    progress: function (e) {
                        if (e.lengthComputable) {
                            uploadPercentage = Math.floor(e.loaded * 100 / e.total);

                            // only on a whole-percent change: this runs on a raw
                            // XHR event, so each one costs a full digest
                            if (uploadPercentage === lastPercentage) {
                                return;
                            }

                            lastPercentage = uploadPercentage;

                            $rootScope.$broadcast('recorder-uploading', uploadPercentage, videoId);

                            // without the digest the recorder state that locks
                            // the recipient list never reaches the UI while a
                            // file uploads (THANK-692). The webcam upload
                            // already does this.
                            $rootScope.$apply();
                        }
                    },
                    success: function (response) {
                        if (response.success) {
                            response.video.video_type = 'upload';
                            response.video.start_trim = 0;
                            response.video.video_thumb = response.video.video_thumbs[0];

                            $rootScope.$broadcast('recorder-upload-complete', response.video, videoId);
                        } else {
                            uploadService.reportError();
                            $rootScope.$broadcast('recorder-upload-failed');
                            $rootScope.$broadcast('open-message', response.message, { showContact: true });
                        }

                        $rootScope.$apply();
                    },
                    error: function () {
                        uploadService.reportError();
                        $rootScope.$broadcast('recorder-upload-failed');
                        $rootScope.$apply();
                    },
                });
            };

            uploadService.reportError = function () {
                if ($window.Bugsnag) {
                    Bugsnag.notify(new Error('Recorder Upload Service Error'), (event) => {
                        event.addMetadata('custom', { 'File Uploaded': uploadService.getUploadFileMetadata() });
                    });
                }
            };

            /**
             * Helper function that gets basic information about the file the user provided
             */
            uploadService.getUploadFileMetadata = function () {
                if (!uploadFile) return {};
                return {
                    name: uploadFile.name,
                    size: uploadFile.size,
                    type: uploadFile.type,
                };
            };

            return uploadService;
        }]);
}());
